<button
  class="noPrint btn-primary"
  style="width: 10%; margin-left: 80%;"
  mat-raised-button
  color="primary"
  ngxPrint
  printSectionId="print-section"
  [useExistingCss]="true">
  print
</button>

<div id="print-section">
  <ng-container *ngFor="let note of creditNoteList; let i = index">
    <div class="credit-note-wrapper">
      <!-- ================= CREDIT NOTE START ================= -->
      <div class="container" style="border: 2px solid black">

        <div class="row">
          <div class="col-2">
            <img
              style="margin-top: 30%"
              width="100%"
              src="../../../assets/img/brand/book.png"
            />
          </div>

          <div
            class="col-8"
            style="padding-top: 30px; text-align: center; padding-bottom: 10px"
          >
            <span style="font-size: 35px; font-weight: bold">
              हिंदुस्थान प्रकाशन संस्था
            </span>
            <span style="font-size: 13px; margin-left: 5px">
              (Reg.No.-BOM-3/1961(GBBSD)
            </span>
            <hr />

            <div class="row" style="text-align: left">
              <div class="col-6" style="padding-top: 12px">
                <span style="font-size: 14px">
                  <span style="font-weight: bold; font-size: 16px">
                    प्रशासकीय कार्यालय :
                  </span>
                  116, 117, 118, 119, पहिला मजला, शिल्पीन सेंटर,
                  ग. द. आंबेकर मार्ग, वडाळा , मुंबई - 400031.
                </span><br />
                <span style="font-size: 14px">
                  <span style="font-weight: bold; font-size: 14px">दूरध्वनी:</span>
                  27810235, 27810236
                </span>
              </div>

              <div
                class="col-6"
                style="border-style: solid; border-width: 0px 0px 0px 2px; padding-top: 12px"
              >
                <span style="font-size: 14px">
                  <span style="font-weight: bold; font-size: 14px">
                    मुख्य कार्यालय :
                  </span>
                  5/12, कामत औद्योगिक वसाहत,
                  396 स्वा. वीर सावरकर मार्ग,
                  प्रभादेवी, मुंबई 400025.
                </span><br />
                <span style="font-size: 13px">
                  <span style="font-weight: bold; font-size: 14px">
                    दूरध्वनी :
                  </span>
                  24221440
                </span>
              </div>
            </div>
          </div>

          <div
            class="col-2"
            style="border-style: solid; border-width: 0px 0px 0px 2px; padding-top: 80px; text-align: center"
          >
            <span style="font-weight: bold; font-size: 23px">क्रेडिट नोट</span>
          </div>
        </div>

        <div class="row" style="border-top: 2px solid black">
          <div class="col-6" style="padding-top: 20px; text-align: left">
            <span style="font-weight: bold; font-size: 15px">
              Book Seller Name:&nbsp;
            </span>
            <span style="font-size: 14px">
              {{ note.crdtnote_no_data[0]['book_seller_name'] }}
            </span><br />

            <span style="font-weight: bold; font-size: 15px">
              Address :&nbsp;
            </span>

            <span
              style="
                font-size: 14px;
                display: inline-block;
                width: 100%;
                white-space: normal;
                word-break: break-word;
                overflow-wrap: anywhere;
              "
            >
              {{ note.fullAddress }}
            </span>
             <span style="font-weight: bold; font-size: 15px">
              Mobile No:
            </span>
            <span style="font-size: 14px">
              {{ note.crdtnote_no_data[0]['mobile_no'] }}
            </span><br />
          </div>

          <div
            class="col-6"
            style="border-style: solid; border-width: 0px 0px 0px 2px"
          >
            <div
              class="row"
              style="border-style: solid; border-width: 0px 0px 2px 0px; padding-top: 30px; padding-bottom: 20px"
            >
              <div class="col-6" style="text-align: left">
                <span style="font-weight: bold; font-size: 14px;text-align: left">
                  क्रेडिट नोट क्रं : <span style="font-size:14px;font-weight:bold;" >{{ note.crdtnote_no }}</span>
                </span>
              </div>
              <div class="col-6" style="text-align: left">
                <span style="font-weight: bold; font-size: 15px">
                  दिनांक:&nbsp;
                </span>
                {{ note.crdtnote_no_data[0].date | date:'dd-MM-yyyy' }}
              </div>
            </div>

            <div class="row" style="padding-top: 20px">
              <div class="col-12" style="text-align: left">
                <span style="font-weight: bold; font-size: 15px">
                  क्रेडिट नोट रक्कम रू-&nbsp;
                </span>
                {{ note.totalAmount }}/-
              </div>
            </div>

            <div class="row">
              <div class="col-12" style="text-align: right">
                <span style="font-weight: bold; font-size: 15px">
                  काढण्यात आली.
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-12" style="text-align: left; padding-bottom: 10px">
                <span style="font-weight: bold; font-size: 15px">
                  अक्षरी रक्कम.&nbsp;
                </span>
                {{ note.crdtnotetotalwords }}
              </div>
            </div>
          </div>
        </div>

        <div class="row text-center" style="border-top: 2px solid black">
          <div class="col-2 tableDescheader">बिल नंबर</div>
          <div class="col-2 tableDescheader">रक्कम</div>
          <div class="col-2 tableDescheader">राहिलेले बाकी</div>
          <div class="col-2 tableDescheader">क्रेडिट नोट रक्कम</div>
          <div class="col-2 tableDescheader">येणेबाकी</div>
          <div class="col-2 tableDescheader">Remark</div>
        </div>

        <div class="row" *ngFor="let item of note.crdtnote_no_data">
          <div class="col-2 tableDesc">{{ item.invoice_no }}</div>
          <div class="col-2 tableDesc">{{ item.bill_amount }}</div>
          <div class="col-2 tableDesc">{{ item.previous_rem }}</div>
          <div class="col-2 tableDesc">{{ item.crdtnote_total }}</div>
          <div class="col-2 tableDesc">
            {{ item.previous_rem - item.crdtnote_total }}
          </div>
          <div class="col-2 tableDesc">{{ item.credit_remark }}</div>
        </div>

        <div class="row">
          <div class="col-2 tableDesc" style="font-weight: bold">Total -</div>
          <div class="col-2 tableDesc" style="font-weight: bold">
            {{ note.total_bill_amount }}
          </div>
          <div class="col-2 tableDesc" style="font-weight: bold">
            {{ note.total_remaining_amt }}
          </div>
          <div class="col-2 tableDesc" style="font-weight: bold">
            {{ note.total_crdtnote_total }}
          </div>
          <div class="col-2 tableDesc" style="font-weight: bold">
            {{ (+note.total_remaining_amt || 0) - (+note.total_crdtnote_total || 0) }}
          </div>
          <div class="col-2 tableDesc"></div>
        </div>

        <div class="row" style="margin-top: 10%; padding-bottom: 1%">
          <div class="col-12" style="text-align: right; font-weight: bold">
            व्यवस्थापक / लेखापाल
          </div>
        </div>

      </div>
      <!-- ================= CREDIT NOTE END ================= -->
    </div>

    <!-- ===== PAGE BREAK AFTER EVERY 2 NOTES ===== -->
    <div
      class="page-break"
      *ngIf="(i + 1) % 2 === 0 && (i + 1) < creditNoteList.length"
    ></div>
  </ng-container>
</div>

<style>
@media print {
  .noPrint {
    display: none !important;
  }

  @page {
    size: A4 portrait;
    margin: 10mm;
  }

  .page-break {
    page-break-after: always;
    height: 0;
    margin: 0;
    padding: 0;
  }

  .credit-note-wrapper {
    margin: 0 !important;
    padding: 0;
    page-break-inside: avoid;
  }

  .credit-note-wrapper:not(:first-child) {
    margin-top: 30mm !important;
  }

  #print-section > .credit-note-wrapper:first-child {
    margin-top: 0 !important;
  }

  .container {
    page-break-inside: avoid;
  }

  .row {
    page-break-inside: avoid;
  }

  * {
    -webkit-print-color-adjust: exact;
  }
}

hr {
  border: 0.7px solid black;
  margin-top: 20px;
  margin-bottom: 1px;
}

div.tableDescheader {
  font-weight: bold;
  text-align: center;
  border-style: solid;
  border-width: 0px 1px 1px 1px;
}

div.tableDesc {
  text-align: center;
  border-style: solid;
  border-width: 0px 1px 1px 1px;
}
</style>